export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Featured Merchants",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/e-pasar.jpg",
      title: "e-pasar",
      subtitle: "Great variety of fresh vegetables from RM0.99",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-e-pasar"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/big-nuts-nov.jpg",
      title: "Big Nuts",
      subtitle: "Wide range of nuts selection from RM30.00",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-big-nuts"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/YewChianHaw.jpg",
      title: "Yew Chian Haw",
      subtitle: "Asia's leading producers of abundant varieties of natural herbal products",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-yew-chian-haw"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/DairyFish.jpg",
      title: "Fish Diary Fish For You",
      subtitle: "Fresh fish direct to your doorsteps",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Shop Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-fish-diary-fish-for-you"
    }
  ],
}
